import angular from 'angular';
import emailLenderCheck from './emailLenderCheck';
import './style.scss';

export default angular
  .module('components.emailLenderCheck', [])
  .component('emailLenderCheck', emailLenderCheck).name;
